export enum EMediaFilter {
  All = 'all',
  JustAdded = 'just_added',
  Creators = 'creators'
}
